<div *ngIf="!fileUploaded" class="previewBox" style="background-image: url('assets/floor-border.png');">
    <h1 class="previewMessage">{{heading}}</h1>
</div>

<div class="floorLayoutContainer" *ngIf="fileUploaded" style="background-image: url('/assets/floor-border.png');">
    <section class="floorLayout">
        <app-floor-layout [isFloorPlanAvailable]="true" [layout]="layout">
        </app-floor-layout>
    </section>
</div>


<div class="uploadDiv">
    <div style="display: inline-flex; align-items: center;">
        <span class="uploadCardMessage">{{cardMessage}}</span>
        <div style="height:0px;overflow:hidden; width: 0px;">
            <input style="height:0px; width: 0px" type="file" name="image" (change)="onFileSelected($event)" #fileInput>
        </div>
        <svg class="uploadButton" (click)="uploadExcel()" xmlns="http://www.w3.org/2000/svg" width="104" height="36"
            viewBox="0 0 104 36">
            <g>
                <g fill="#fff" stroke="#0937b2" transform="translate(-1232 -241) translate(1232 241)">
                    <rect width="104" height="36" stroke="none" rx="18" />
                    <rect width="103" height="35" x=".5" y=".5" fill="none" rx="17.5" />
                </g>
                <path fill="none" stroke="#0937b2" stroke-width="2px" d="M14890.354-52.195l4.078 4.077-4.078 4.077"
                    transform="translate(-1232 -241) translate(-13574.58 306.84)" />
                <text fill="#415366" font-family="Lato-Regular, Lato" font-size="12px"
                    transform="translate(-1232 -241) translate(1248 263)">
                    <tspan x="0" y="0">Upload</tspan>
                </text>
            </g>
        </svg>
        <svg *ngIf="fileUploaded" class="uploadButton" (click)="resetPreview()" xmlns="http://www.w3.org/2000/svg"
            width="104" height="36" viewBox="0 0 104 36">
            <g>
                <g fill="#fff" stroke="#0937b2" transform="translate(-1232 -241) translate(1232 241)">
                    <rect width="104" height="36" stroke="none" rx="18" />
                    <rect width="103" height="35" x=".5" y=".5" fill="none" rx="17.5" />
                </g>
                <path fill="none" stroke="#0937b2" stroke-width="2px" d="M14890.354-52.195l4.078 4.077-4.078 4.077"
                    transform="translate(-1232 -241) translate(-13574.58 306.84)" />
                <text fill="#415366" font-family="Lato-Regular, Lato" font-size="12px"
                    transform="translate(-1232 -241) translate(1248 263)">
                    <tspan x="0" y="0">Reset</tspan>
                </text>
            </g>
        </svg>
    </div>
</div>